import { LandingPageComponent } from './landing-page.component';
import { MapComponent } from './map/map.component';
import { AddressSearchComponent } from './address-search/address-search.component';
import { ServicesDescriptionComponent } from './services-description/services-description.component';
import { UploadInputComponent } from './upload-input/upload-input.component';
import { ComuneNoaAutocompleteComponent } from './comune-noa-autocomplete/comune-noa-autocomplete.component';
import { PoiAutocompleteComponent } from './poi-autocomplete/poi-autocomplete.component';
import { CoordinatesSearchComponent } from './coordinates-search/coordinates-search.component';
import { IdSearchComponent } from './id-search/id-search.component';
import { PopAutocompleteComponent } from './pop-autocomplete/pop-autocomplete.component';
import { MassiveImportViewComponent } from './massive-import-view/massive-import-view.component';
import { RoeAutocompleteComponent } from './roe-autocomplete/roe-autocomplete.component';
import { BasicAutocompleteComponent } from './basic-autocomplete/basic-autocomplete.component';
import { ComuneBuildingAutocompleteComponent } from './comune-building-autocomplete/comune-building-autocomplete.component';
import { PfsAutocompleteComponent } from './pfs-autocomplete/pfs-autocomplete.component';
import { ComuneRpiAutocompleteComponent } from './comune-rpi-autocomplete/comune-rpi-autocomplete.component';
import { ComunePoiAutocompleteComponent } from './comune-poi-autocomplete/comune-poi-autocomplete.component';
import { ComunePopAutocompleteComponent } from './comune-pop-autocomplete/comune-pop-autocomplete.component';

export const COMPONENTS = [
  LandingPageComponent,
  MapComponent,
  AddressSearchComponent,
  ServicesDescriptionComponent,
  UploadInputComponent,
  PoiAutocompleteComponent,
  PopAutocompleteComponent,
  ComuneNoaAutocompleteComponent,
  ComuneBuildingAutocompleteComponent,
  CoordinatesSearchComponent,
  IdSearchComponent,
  MassiveImportViewComponent,
  PfsAutocompleteComponent,
  RoeAutocompleteComponent,
  BasicAutocompleteComponent,
  ComuneRpiAutocompleteComponent,
  ComunePoiAutocompleteComponent,
  ComunePopAutocompleteComponent
];

export const mockPop=[
    {
        "id": 936,
        "nome": "AGAAB",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.61645,
        "lat": 37.2506889,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.61645,
                37.2506889
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1900,
        "nome": "AGAC1",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.215903,
        "lat": 37.571487,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.215903,
                37.571487
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 531,
        "nome": "AGAD1",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.791867,
        "lat": 37.257283,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.791867,
                37.257283
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 713,
        "nome": "AGAEA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.383851,
        "lat": 37.437925,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.383851,
                37.437925
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 938,
        "nome": "AGAFA",
        "nazionale": false,
        "type": "AGF",
        "lng": 12.617346,
        "lat": 35.508806,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.617346,
                35.508806
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3981,
        "nome": "AGAFB",
        "nazionale": false,
        "type": "AGF",
        "lng": 12.862546,
        "lat": 35.863009,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.862546,
                35.863009
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 684,
        "nome": "AGAGA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.287242,
        "lat": 37.586939,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.287242,
                37.586939
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 939,
        "nome": "AGAHA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.09087,
        "lat": 37.535004,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.09087,
                37.535004
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5948,
        "nome": "AGAHB",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.07863582,
        "lat": 37.52047423,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.07863582,
                37.52047423
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 287,
        "nome": "AGAJA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.430748,
        "lat": 37.611185,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.430748,
                37.611185
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2212,
        "nome": "AGALA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.285876,
        "lat": 37.526913,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.285876,
                37.526913
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3982,
        "nome": "AGAPA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.5587848,
        "lat": 37.3563034,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.5587848,
                37.3563034
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2875,
        "nome": "AGARA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.3474562,
        "lat": 37.3950647,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.3474562,
                37.3950647
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6093,
        "nome": "AGASA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.8034593,
        "lat": 37.2779342,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.8034593,
                37.2779342
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2638,
        "nome": "AGAUA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.5128265,
        "lat": 37.2935564,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.5128265,
                37.2935564
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2213,
        "nome": "AGAVA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.46634,
        "lat": 37.312123,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.46634,
                37.312123
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 288,
        "nome": "AGAZA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.553058,
        "lat": 37.478809,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.553058,
                37.478809
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2499,
        "nome": "AGBCA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.6476676,
        "lat": 37.5384362,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.6476676,
                37.5384362
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 716,
        "nome": "AGBD1",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.7507,
        "lat": 37.350332,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.7507,
                37.350332
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2107,
        "nome": "AGBFA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.719001,
        "lat": 37.4086096,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.719001,
                37.4086096
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4781,
        "nome": "AGBGA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.629287,
        "lat": 37.631008,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.629287,
                37.631008
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4776,
        "nome": "AGBGB",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.629768,
        "lat": 37.631916,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.629768,
                37.631916
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2216,
        "nome": "AGBIA",
        "nazionale": false,
        "type": "AGF",
        "lng": 12.969554,
        "lat": 37.594886,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.969554,
                37.594886
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 940,
        "nome": "AGBKA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.105444,
        "lat": 37.645941,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.105444,
                37.645941
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 717,
        "nome": "AGBLA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.015835,
        "lat": 37.683274,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.015835,
                37.683274
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2909,
        "nome": "AGBMA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.9217357,
        "lat": 37.2613528,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.9217357,
                37.2613528
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4777,
        "nome": "AGBNA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.926102,
        "lat": 37.11456,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.926102,
                37.11456
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5022,
        "nome": "AGBPA",
        "nazionale": false,
        "type": "AGF",
        "lng": 13.648457,
        "lat": 37.40632,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.648457,
                37.40632
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 76,
        "nome": "AG_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 13.588099,
        "lat": 37.306447,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.588099,
                37.306447
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 545,
        "nome": "ALAEA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.790676,
        "lat": 44.647648,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.790676,
                44.647648
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2257,
        "nome": "ALAFA",
        "nazionale": false,
        "type": "AGF",
        "lng": 9.0456096,
        "lat": 44.7199619,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.0456096,
                44.7199619
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 941,
        "nome": "ALAGA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.521886,
        "lat": 44.603694,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.521886,
                44.603694
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5162,
        "nome": "ALAGS",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.52624,
        "lat": 44.60178,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.52624,
                44.60178
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6486,
        "nome": "ALAIA",
        "nazionale": false,
        "type": "AGF",
        "lng": 9.069094,
        "lat": 44.703519,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.069094,
                44.703519
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2749,
        "nome": "ALAJA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.796564,
        "lat": 44.9997063,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.796564,
                44.9997063
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5033,
        "nome": "ALAKA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.8863535,
        "lat": 45.0180932,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.8863535,
                45.0180932
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 942,
        "nome": "ALANA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.401677,
        "lat": 45.178682,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.401677,
                45.178682
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 943,
        "nome": "ALAOA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.707728,
        "lat": 44.765724,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.707728,
                44.765724
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 944,
        "nome": "ALAPA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.7348,
        "lat": 44.998,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.7348,
                44.998
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5330,
        "nome": "ALAS1",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.973868,
        "lat": 44.729349,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.973868,
                44.729349
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2223,
        "nome": "ALASA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.97386814,
        "lat": 44.72934866,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.97386814,
                44.72934866
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6388,
        "nome": "ALATA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.520285,
        "lat": 45.091528,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.520285,
                45.091528
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6389,
        "nome": "ALAVA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.688942,
        "lat": 44.824323,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.688942,
                44.824323
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1905,
        "nome": "ALAX1",
        "nazionale": false,
        "type": "AGF",
        "lng": 9.040334,
        "lat": 44.811556,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.040334,
                44.811556
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2626,
        "nome": "ALBBS",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.468714,
        "lat": 44.827848,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.468714,
                44.827848
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 846,
        "nome": "ALBC1",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.896655,
        "lat": 44.806452,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.896655,
                44.806452
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2624,
        "nome": "ALBDA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.6296785,
        "lat": 44.7001392,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.6296785,
                44.7001392
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2108,
        "nome": "ALBFA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.83233109,
        "lat": 44.65940501,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.83233109,
                44.65940501
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2303,
        "nome": "ALBHA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.626578,
        "lat": 44.83518,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.626578,
                44.83518
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3980,
        "nome": "ALBJA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.9836181,
        "lat": 44.9122325,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.9836181,
                44.9122325
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 945,
        "nome": "ALBM1",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.561944,
        "lat": 44.602239,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.561944,
                44.602239
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1966,
        "nome": "ALBY1",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.36304,
        "lat": 45.145875,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.36304,
                45.145875
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6094,
        "nome": "ALBZA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.455475,
        "lat": 45.026764,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.455475,
                45.026764
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1859,
        "nome": "ALCA1",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.924218,
        "lat": 44.820025,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.924218,
                44.820025
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5119,
        "nome": "ALCBA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.58583986,
        "lat": 44.63749767,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.58583986,
                44.63749767
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5118,
        "nome": "ALCDS",
        "nazionale": false,
        "type": "AGF",
        "lng": 9.157224,
        "lat": 44.775119,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.157224,
                44.775119
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2065,
        "nome": "ALCHA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.52889412,
        "lat": 45.13334014,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.52889412,
                45.13334014
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2238,
        "nome": "ALCKA",
        "nazionale": false,
        "type": "AGF",
        "lng": 8.541748,
        "lat": 44.810414,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.541748,
                44.810414
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6390,
        "nome": "ALCLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.993753,
        "lat": 44.778046,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.993753,
                44.778046
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3975,
        "nome": "ALCOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.563431,
        "lat": 45.059651,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.563431,
                45.059651
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2263,
        "nome": "ALCPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.099553,
        "lat": 44.805908,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.099553,
                44.805908
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1860,
        "nome": "ALCQ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.489631,
        "lat": 44.630831,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.489631,
                44.630831
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 847,
        "nome": "ALCR1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.963138,
        "lat": 44.697442,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.963138,
                44.697442
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5626,
        "nome": "ALCVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.489361,
        "lat": 45.002222,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.489361,
                45.002222
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2517,
        "nome": "ALCXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.414457,
        "lat": 44.867574,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.414457,
                44.867574
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6656,
        "nome": "ALCY1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.41771039,
        "lat": 44.64180522,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.41771039,
                44.64180522
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6521,
        "nome": "ALCYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.41771,
        "lat": 44.641805,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.41771,
                44.641805
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2109,
        "nome": "ALCZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.530698,
        "lat": 45.029938,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.530698,
                45.029938
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5415,
        "nome": "ALDF1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.10687493,
        "lat": 44.76675329,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.10687493,
                44.76675329
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2648,
        "nome": "ALDI1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.68660651,
        "lat": 44.94895015,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.68660651,
                44.94895015
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6100,
        "nome": "ALDJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.942896,
        "lat": 44.842628,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.942896,
                44.842628
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2438,
        "nome": "ALDKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.993078,
        "lat": 44.848756,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.993078,
                44.848756
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2073,
        "nome": "ALDOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.50726261,
        "lat": 45.0618213,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.50726261,
                45.0618213
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4794,
        "nome": "ALDQ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.64638692,
        "lat": 44.63746785,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.64638692,
                44.63746785
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 946,
        "nome": "ALDRA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.491108,
        "lat": 44.865274,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.491108,
                44.865274
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2634,
        "nome": "ALDVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.74903841,
        "lat": 44.75067788,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.74903841,
                44.75067788
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5028,
        "nome": "ALDWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.6761066,
        "lat": 44.9937102,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.6761066,
                44.9937102
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2935,
        "nome": "ALDXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.670775,
        "lat": 44.948154,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.670775,
                44.948154
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2439,
        "nome": "ALDZ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.596045,
        "lat": 45.061353,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.596045,
                45.061353
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2078,
        "nome": "ALEBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.33803781,
        "lat": 45.14166518,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.33803781,
                45.14166518
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5834,
        "nome": "ALEHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.496023,
        "lat": 44.942785,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.496023,
                44.942785
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6391,
        "nome": "ALEKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.649736,
        "lat": 44.672468,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.649736,
                44.672468
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 848,
        "nome": "ALEM1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.050956,
        "lat": 44.705383,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.050956,
                44.705383
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2510,
        "nome": "ALEPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.8367222,
        "lat": 44.9690425,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.8367222,
                44.9690425
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2247,
        "nome": "ALEQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.747066,
        "lat": 44.691758,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.747066,
                44.691758
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 947,
        "nome": "ALETA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.069061,
        "lat": 44.787373,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.069061,
                44.787373
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2306,
        "nome": "ALEU1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.91484675,
        "lat": 44.78829052,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.91484675,
                44.78829052
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1815,
        "nome": "ALEV1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.910009,
        "lat": 44.755791,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.910009,
                44.755791
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6368,
        "nome": "ALEWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.91425,
        "lat": 44.867681,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.91425,
                44.867681
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5839,
        "nome": "ALEYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.5699703,
        "lat": 44.7858803,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.5699703,
                44.7858803
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 948,
        "nome": "ALEZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.670868,
        "lat": 44.686946,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.670868,
                44.686946
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2110,
        "nome": "ALFGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.444547,
        "lat": 45.082982,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.444547,
                45.082982
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3327,
        "nome": "ALFIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.5572536,
        "lat": 45.0951906,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.5572536,
                45.0951906
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1906,
        "nome": "ALFJ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.365274,
        "lat": 45.096857,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.365274,
                45.096857
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5121,
        "nome": "ALFKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.5834815,
        "lat": 44.6592972,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.5834815,
                44.6592972
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6105,
        "nome": "ALFNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.894972,
        "lat": 44.707713,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.894972,
                44.707713
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 950,
        "nome": "ALFOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.920836,
        "lat": 44.909963,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.920836,
                44.909963
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5060,
        "nome": "ALFSA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.506543,
        "lat": 44.662317,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.506543,
                44.662317
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3772,
        "nome": "ALFTA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.979543,
        "lat": 44.889707,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.979543,
                44.889707
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6392,
        "nome": "ALFVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.841834,
        "lat": 44.625533,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.841834,
                44.625533
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2239,
        "nome": "ALFWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.20008332,
        "lat": 45.05105552,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.20008332,
                45.05105552
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2912,
        "nome": "ALFXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.4545833,
        "lat": 44.7271667,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.4545833,
                44.7271667
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5130,
        "nome": "ALFYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.376673,
        "lat": 44.994159,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.376673,
                44.994159
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2756,
        "nome": "ALFYS",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.388524,
        "lat": 44.975385,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.388524,
                44.975385
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5145,
        "nome": "ALFZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.452983,
        "lat": 44.8275605,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.452983,
                44.8275605
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2224,
        "nome": "ALGDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.239689,
        "lat": 45.063115,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.239689,
                45.063115
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6393,
        "nome": "ALGFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.316419,
        "lat": 45.092109,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.316419,
                45.092109
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6524,
        "nome": "ALGGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.2119658,
        "lat": 45.1133282,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.2119658,
                45.1133282
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2755,
        "nome": "ALGH1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.457097,
        "lat": 44.990584,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.457097,
                44.990584
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2176,
        "nome": "ALGKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.430035,
        "lat": 44.9616008,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.430035,
                44.9616008
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2795,
        "nome": "ALGMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.2537334,
        "lat": 45.1189015,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.2537334,
                45.1189015
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4778,
        "nome": "ALGOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.1312286,
        "lat": 45.080227,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.1312286,
                45.080227
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6525,
        "nome": "ALGPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.1645703,
        "lat": 45.0955466,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.1645703,
                45.0955466
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1814,
        "nome": "ALGR1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.366598,
        "lat": 45.03753,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.366598,
                45.03753
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2229,
        "nome": "ALGTA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.430108,
        "lat": 44.4523509,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.430108,
                44.4523509
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3773,
        "nome": "ALGUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.36603,
        "lat": 44.625563,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.36603,
                44.625563
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6653,
        "nome": "ALGWS",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.383227,
        "lat": 44.9028,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.383227,
                44.9028
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2111,
        "nome": "ALGYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.2835862,
        "lat": 45.0999596,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.2835862,
                45.0999596
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3531,
        "nome": "ALGZ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.2537334,
        "lat": 45.1189015,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.2537334,
                45.1189015
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2084,
        "nome": "ALHAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.3315386,
        "lat": 44.54326672,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.3315386,
                44.54326672
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2520,
        "nome": "ALHBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.394016,
        "lat": 45.0126853,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.394016,
                45.0126853
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2777,
        "nome": "ALHCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.16969885,
        "lat": 45.07244218,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.16969885,
                45.07244218
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2896,
        "nome": "ALHCS",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.181701,
        "lat": 45.06752,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.181701,
                45.06752
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5589,
        "nome": "ALHDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.245823,
        "lat": 45.156786,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.245823,
                45.156786
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 953,
        "nome": "ALHEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.176161,
        "lat": 45.158328,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.176161,
                45.158328
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5605,
        "nome": "ALHG1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.16975728,
        "lat": 45.13444627,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.16975728,
                45.13444627
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 58,
        "nome": "AL_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 8.626544,
        "lat": 44.910254,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.626544,
                44.910254
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 612,
        "nome": "AL_02",
        "nazionale": false,
        "type": "Primary",
        "lng": 8.4422873,
        "lat": 45.1159107,
        "pop_aperto": false,
        "coordinates": {
            "coordinates": [
                8.4422873,
                45.1159107
            ],
            "type": "Point"
        },
        "show": false
    },
    {
        "id": 584,
        "nome": "AL_03",
        "nazionale": false,
        "type": "Primary",
        "lng": 8.767728,
        "lat": 44.766476,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.767728,
                44.766476
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 627,
        "nome": "AL_04",
        "nazionale": false,
        "type": "Primary",
        "lng": 8.8622867,
        "lat": 44.8943397,
        "pop_aperto": false,
        "coordinates": {
            "coordinates": [
                8.8622867,
                44.8943397
            ],
            "type": "Point"
        },
        "show": false
    },
    {
        "id": 954,
        "nome": "ANACA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.999685,
        "lat": 43.33942,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.999685,
                43.33942
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1835,
        "nome": "ANAD1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.274819,
        "lat": 43.547785,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.274819,
                43.547785
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5031,
        "nome": "ANAFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.170965,
        "lat": 43.663575,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.170965,
                43.663575
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4932,
        "nome": "ANAGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.8704735,
        "lat": 43.3976361,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.8704735,
                43.3976361
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2289,
        "nome": "ANAIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.026379,
        "lat": 43.579115,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.026379,
                43.579115
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2119,
        "nome": "ANALA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.34114117,
        "lat": 43.58263675,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.34114117,
                43.58263675
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6526,
        "nome": "ANAOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.977228,
        "lat": 43.606599,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.977228,
                43.606599
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2266,
        "nome": "ANAPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.086771,
        "lat": 43.484244,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.086771,
                43.484244
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 718,
        "nome": "ANATA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.119073,
        "lat": 43.448347,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.119073,
                43.448347
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1868,
        "nome": "ANAU1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.365896,
        "lat": 43.64216,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.365896,
                43.64216
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 955,
        "nome": "ANAVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.979555,
        "lat": 43.404527,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.979555,
                43.404527
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1836,
        "nome": "ANAW1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.658101,
        "lat": 43.436054,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.658101,
                43.436054
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2900,
        "nome": "ANAZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.28334,
        "lat": 43.559637,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.28334,
                43.559637
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 768,
        "nome": "ANBBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.284954,
        "lat": 43.598123,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.284954,
                43.598123
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5265,
        "nome": "ANBC1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.078033,
        "lat": 43.533733,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.078033,
                43.533733
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 958,
        "nome": "ANBGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.4464522,
        "lat": 43.5264167,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.4464522,
                43.5264167
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 959,
        "nome": "ANBHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.1636602,
        "lat": 43.6213097,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.1636602,
                43.6213097
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2277,
        "nome": "ANBJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.075179,
        "lat": 43.51429,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.075179,
                43.51429
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 960,
        "nome": "ANBLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.06059,
        "lat": 43.46204,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.06059,
                43.46204
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2271,
        "nome": "ANBNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.1759826,
        "lat": 43.4654259,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.1759826,
                43.4654259
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4974,
        "nome": "ANBOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.3149001,
        "lat": 43.4945274,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.3149001,
                43.4945274
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 961,
        "nome": "ANBPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.0293882,
        "lat": 43.5399847,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.0293882,
                43.5399847
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2950,
        "nome": "ANBQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.06059,
        "lat": 43.46204,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.06059,
                43.46204
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6369,
        "nome": "ANBTA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.41288048,
        "lat": 43.45593918,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.41288048,
                43.45593918
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5899,
        "nome": "ANBUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.181149,
        "lat": 43.432897,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.181149,
                43.432897
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 258,
        "nome": "AN_01",
        "nazionale": true,
        "type": "Nazionale",
        "lng": 13.50106,
        "lat": 43.570916,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.50106,
                43.570916
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 138,
        "nome": "AN_02",
        "nazionale": false,
        "type": "Primary",
        "lng": 13.513055,
        "lat": 43.605916,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.513055,
                43.605916
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 102,
        "nome": "AN_03",
        "nazionale": false,
        "type": "Primary",
        "lng": 12.926627,
        "lat": 43.346906,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.926627,
                43.346906
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 585,
        "nome": "AN_04",
        "nazionale": false,
        "type": "Primary",
        "lng": 13.2290904,
        "lat": 43.5277482,
        "pop_aperto": false,
        "coordinates": {
            "coordinates": [
                13.2290904,
                43.5277482
            ],
            "type": "Point"
        },
        "show": false
    },
    {
        "id": 608,
        "nome": "AN_05",
        "nazionale": false,
        "type": "Primary",
        "lng": 13.4787963,
        "lat": 43.4727826,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.4787963,
                43.4727826
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 278,
        "nome": "AN_06",
        "nazionale": false,
        "type": "Primary",
        "lng": 13.210296,
        "lat": 43.722802,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.210296,
                43.722802
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6361,
        "nome": "AOABA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.587768,
        "lat": 45.806803,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.587768,
                45.806803
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2132,
        "nome": "AOACA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.24031217,
        "lat": 45.7010252,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.24031217,
                45.7010252
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 965,
        "nome": "AOAFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.8257046,
        "lat": 45.7744322,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.8257046,
                45.7744322
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 393,
        "nome": "AOAGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.775448,
        "lat": 45.603983,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.775448,
                45.603983
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5918,
        "nome": "AOAHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.272021,
        "lat": 45.808189,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.272021,
                45.808189
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5924,
        "nome": "AOAJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.16933,
        "lat": 45.7036629,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.16933,
                45.7036629
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 549,
        "nome": "AOALA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.695343,
        "lat": 45.797152,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.695343,
                45.797152
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6077,
        "nome": "AOANA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.398061,
        "lat": 45.864615,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.398061,
                45.864615
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5599,
        "nome": "AOARA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.547693,
        "lat": 45.7440447,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.547693,
                45.7440447
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6394,
        "nome": "AOASA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.623943,
        "lat": 45.837216,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.623943,
                45.837216
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2665,
        "nome": "AOAUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.6367962,
        "lat": 45.6226294,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.6367962,
                45.6226294
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6395,
        "nome": "AOAVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.332827,
        "lat": 45.727719,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.332827,
                45.727719
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 966,
        "nome": "AOAWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.609981,
        "lat": 45.74542,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.609981,
                45.74542
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 967,
        "nome": "AOAXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.350789,
        "lat": 45.611333,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.350789,
                45.611333
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 968,
        "nome": "AOAZ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.715016,
        "lat": 45.731545,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.715016,
                45.731545
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6362,
        "nome": "AOBAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.22993,
        "lat": 45.821311,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.22993,
                45.821311
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3820,
        "nome": "AOBDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.881146,
        "lat": 45.71455,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.881146,
                45.71455
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3821,
        "nome": "AOBGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.825449,
        "lat": 45.826537,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.825449,
                45.826537
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5023,
        "nome": "AOBIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.187792,
        "lat": 45.696851,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.187792,
                45.696851
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1816,
        "nome": "AOBJ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.854784,
        "lat": 45.68444,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.854784,
                45.68444
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2307,
        "nome": "AOBMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.619901,
        "lat": 45.811143,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.619901,
                45.811143
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2283,
        "nome": "AOBPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.839713,
        "lat": 45.633425,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.839713,
                45.633425
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6396,
        "nome": "AOBSA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.466702,
        "lat": 45.740159,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.466702,
                45.740159
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6124,
        "nome": "AOBUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.381835,
        "lat": 45.85057,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.381835,
                45.85057
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2284,
        "nome": "AOBVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.803243,
        "lat": 45.604141,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.803243,
                45.604141
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1940,
        "nome": "AOBXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.687544,
        "lat": 45.606504,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.687544,
                45.606504
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2667,
        "nome": "AOBYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.591465,
        "lat": 45.738493,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.591465,
                45.738493
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 550,
        "nome": "AOCCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.122699,
        "lat": 45.578314,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.122699,
                45.578314
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2790,
        "nome": "AOCEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.3090117,
        "lat": 45.783719,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.3090117,
                45.783719
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4934,
        "nome": "AOCGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.557436,
        "lat": 45.752253,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.557436,
                45.752253
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6397,
        "nome": "AOCHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.441023,
        "lat": 45.739036,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.441023,
                45.739036
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5937,
        "nome": "AOCIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.198002,
        "lat": 45.709708,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.198002,
                45.709708
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 972,
        "nome": "AOCKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.222765,
        "lat": 45.708327,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.222765,
                45.708327
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6363,
        "nome": "AOCLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.177503,
        "lat": 45.821647,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.177503,
                45.821647
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6527,
        "nome": "AOCPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.067892,
        "lat": 45.636922,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.067892,
                45.636922
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4935,
        "nome": "AOCQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.3237063,
        "lat": 45.8260053,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.3237063,
                45.8260053
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 392,
        "nome": "AOCUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.690943,
        "lat": 45.661417,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.690943,
                45.661417
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 106,
        "nome": "AO_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 7.330733,
        "lat": 45.739025,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.330733,
                45.739025
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 974,
        "nome": "APACA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.298324,
        "lat": 42.773846,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.298324,
                42.773846
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2115,
        "nome": "APAEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.8452085,
        "lat": 42.9536897,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.8452085,
                42.9536897
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 863,
        "nome": "APAF1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.664352,
        "lat": 42.895737,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.664352,
                42.895737
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 975,
        "nome": "APAGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.702416,
        "lat": 42.861058,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.702416,
                42.861058
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2276,
        "nome": "APAI1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.728778,
        "lat": 42.866015,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.728778,
                42.866015
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 574,
        "nome": "APAKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.691743,
        "lat": 42.984795,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.691743,
                42.984795
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 976,
        "nome": "APAMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.633642,
        "lat": 42.835415,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.633642,
                42.835415
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 685,
        "nome": "APARA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.752691,
        "lat": 43.050338,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.752691,
                43.050338
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5041,
        "nome": "APASA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.3289728,
        "lat": 42.820893,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.3289728,
                42.820893
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 978,
        "nome": "APATA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.845122,
        "lat": 42.8944483,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.845122,
                42.8944483
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 719,
        "nome": "APAVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.768924,
        "lat": 42.995369,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.768924,
                42.995369
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 979,
        "nome": "APAWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.4899215,
        "lat": 42.8415133,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.4899215,
                42.8415133
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1837,
        "nome": "APBB1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.51322,
        "lat": 42.990042,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.51322,
                42.990042
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 337,
        "nome": "APBCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.606103,
        "lat": 42.988342,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.606103,
                42.988342
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5043,
        "nome": "APBEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.324681,
        "lat": 42.899495,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.324681,
                42.899495
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 746,
        "nome": "APBF1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.463756,
        "lat": 42.92078,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.463756,
                42.92078
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 191,
        "nome": "AP_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 13.589372,
        "lat": 42.851249,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.589372,
                42.851249
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 448,
        "nome": "AP_02",
        "nazionale": false,
        "type": "Primary",
        "lng": 13.876455,
        "lat": 42.957339,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.876455,
                42.957339
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 576,
        "nome": "AQABA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.775196,
        "lat": 42.029989,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.775196,
                42.029989
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5141,
        "nome": "AQAC1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.274577462426,
        "lat": 42.50824072168,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.274577462426,
                42.50824072168
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 980,
        "nome": "AQACA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.249718,
        "lat": 42.519812,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.249718,
                42.519812
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6123,
        "nome": "AQACS",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.24977375,
        "lat": 42.51981386,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.24977375,
                42.51981386
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 981,
        "nome": "AQADA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.053672,
        "lat": 41.870438,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.053672,
                41.870438
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 983,
        "nome": "AQAGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.075109,
        "lat": 42.091972,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.075109,
                42.091972
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 325,
        "nome": "AQAIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.636502,
        "lat": 42.27688,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.636502,
                42.27688
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 984,
        "nome": "AQAJ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.699583,
        "lat": 42.126111,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.699583,
                42.126111
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 985,
        "nome": "AQAKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.725597,
        "lat": 42.177853,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.725597,
                42.177853
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 986,
        "nome": "AQALA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.032961,
        "lat": 42.009846,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.032961,
                42.009846
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2685,
        "nome": "AQANA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.942692,
        "lat": 41.776087,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.942692,
                41.776087
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 989,
        "nome": "AQAPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.5273258,
        "lat": 42.2135719,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.5273258,
                42.2135719
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6528,
        "nome": "AQAQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.582149,
        "lat": 42.056918,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.582149,
                42.056918
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5299,
        "nome": "AQARA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.027167,
        "lat": 41.73295,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.027167,
                41.73295
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2536,
        "nome": "AQASA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.80234,
        "lat": 42.000579,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.80234,
                42.000579
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2758,
        "nome": "AQATA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.280052,
        "lat": 42.454012,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.280052,
                42.454012
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2646,
        "nome": "AQAUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.992151,
        "lat": 41.750921,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.992151,
                41.750921
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 990,
        "nome": "AQAV1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.757524,
        "lat": 41.942702,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.757524,
                41.942702
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1817,
        "nome": "AQAY1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.01761,
        "lat": 42.002815,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.01761,
                42.002815
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 562,
        "nome": "AQAZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.758272,
        "lat": 42.271017,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.758272,
                42.271017
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5123,
        "nome": "AQBAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.300646,
        "lat": 42.521967,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.300646,
                42.521967
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 991,
        "nome": "AQBCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.276701,
        "lat": 42.006639,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.276701,
                42.006639
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 720,
        "nome": "AQBE1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.739213,
        "lat": 42.117197,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.739213,
                42.117197
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 992,
        "nome": "AQBFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.103011,
        "lat": 41.789289,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.103011,
                41.789289
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2436,
        "nome": "AQBHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.545333,
        "lat": 42.050375,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.545333,
                42.050375
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2398,
        "nome": "AQBIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.600962,
        "lat": 42.061118,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.600962,
                42.061118
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 993,
        "nome": "AQBJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.4545,
        "lat": 41.879111,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.4545,
                41.879111
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2371,
        "nome": "AQBKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.943589,
        "lat": 41.76733,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.943589,
                41.76733
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2907,
        "nome": "AQBLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.615904,
        "lat": 42.049532,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.615904,
                42.049532
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 680,
        "nome": "AQBM1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.781556,
        "lat": 42.219804,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.781556,
                42.219804
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2911,
        "nome": "AQBNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.837233,
        "lat": 42.12077,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.837233,
                42.12077
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2315,
        "nome": "AQBOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.5853,
        "lat": 42.263959,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.5853,
                42.263959
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2004,
        "nome": "AQBPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.606858,
        "lat": 42.231122,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.606858,
                42.231122
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 994,
        "nome": "AQBQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.492001,
        "lat": 42.297768,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.492001,
                42.297768
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2318,
        "nome": "AQBRA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.773889,
        "lat": 42.082475,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.773889,
                42.082475
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 996,
        "nome": "AQBS1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.735113,
        "lat": 42.153988,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.735113,
                42.153988
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2320,
        "nome": "AQBTA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.726256,
        "lat": 42.236644,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.726256,
                42.236644
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2647,
        "nome": "AQBUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.473816,
        "lat": 42.283595,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.473816,
                42.283595
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 326,
        "nome": "AQBVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.760268,
        "lat": 42.325066,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.760268,
                42.325066
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4936,
        "nome": "AQBWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.83268,
        "lat": 41.782131,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.83268,
                41.782131
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5537,
        "nome": "AQBXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.711252,
        "lat": 42.017478,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.711252,
                42.017478
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2440,
        "nome": "AQBYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.651358,
        "lat": 41.953257,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.651358,
                41.953257
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2313,
        "nome": "AQBZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.09401,
        "lat": 42.061416,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.09401,
                42.061416
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 997,
        "nome": "AQCAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.791982,
        "lat": 41.80586,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.791982,
                41.80586
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 998,
        "nome": "AQCCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.879228,
        "lat": 42.101207,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.879228,
                42.101207
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2311,
        "nome": "AQCDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.067496,
        "lat": 42.026245,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.067496,
                42.026245
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1919,
        "nome": "AQCE1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.489647,
        "lat": 42.23451,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.489647,
                42.23451
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2437,
        "nome": "AQCEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.489647,
        "lat": 42.23451,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.489647,
                42.23451
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 721,
        "nome": "AQCH1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.769021,
        "lat": 42.185273,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.769021,
                42.185273
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2396,
        "nome": "AQCJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.510997,
        "lat": 42.280519,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.510997,
                42.280519
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3019,
        "nome": "AQCL1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.03989,
        "lat": 41.747652,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.03989,
                41.747652
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 999,
        "nome": "AQCLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.042309,
        "lat": 41.749353,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.042309,
                41.749353
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1000,
        "nome": "AQCM1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.683086,
        "lat": 42.152517,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.683086,
                42.152517
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 722,
        "nome": "AQCN1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.643528,
        "lat": 42.210083,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.643528,
                42.210083
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1920,
        "nome": "AQCP1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.532132,
        "lat": 42.268494,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.532132,
                42.268494
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5959,
        "nome": "AQCQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.8434477,
        "lat": 41.935497,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.8434477,
                41.935497
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 723,
        "nome": "AQCR1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.620732,
        "lat": 41.872559,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.620732,
                41.872559
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5154,
        "nome": "AQCSA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.817786,
        "lat": 42.123667,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.817786,
                42.123667
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1001,
        "nome": "AQTSA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.340122,
        "lat": 42.298146,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.340122,
                42.298146
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1002,
        "nome": "AQUSA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 13.516354,
        "lat": 42.142144,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.516354,
                42.142144
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 159,
        "nome": "AQ_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 13.412085,
        "lat": 42.348173,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.412085,
                42.348173
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 609,
        "nome": "AQ_02",
        "nazionale": false,
        "type": "Primary",
        "lng": 13.428162,
        "lat": 42.028482,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                13.428162,
                42.028482
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 662,
        "nome": "ARABA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.094102,
        "lat": 43.530622,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.094102,
                43.530622
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1003,
        "nome": "ARACA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.186403,
        "lat": 43.704079,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.186403,
                43.704079
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 542,
        "nome": "ARADA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.836226,
        "lat": 43.647997,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.836226,
                43.647997
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1005,
        "nome": "ARAJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.609589,
        "lat": 43.474769,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.609589,
                43.474769
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1006,
        "nome": "ARAKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.862558,
        "lat": 43.566503,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.862558,
                43.566503
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6125,
        "nome": "ARALA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.987061,
        "lat": 43.63662,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.987061,
                43.63662
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 543,
        "nome": "ARAMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.7372,
        "lat": 43.740177,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.7372,
                43.740177
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1007,
        "nome": "ARANA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.546055,
        "lat": 43.639038,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.546055,
                43.639038
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6529,
        "nome": "ARAPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.8578952,
        "lat": 43.2939095,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.8578952,
                43.2939095
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1008,
        "nome": "ARASA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.804977,
        "lat": 43.410734,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.804977,
                43.410734
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5497,
        "nome": "ARAUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.714306,
        "lat": 43.505295,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.714306,
                43.505295
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1009,
        "nome": "ARAVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.621228,
        "lat": 43.584542,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.621228,
                43.584542
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 790,
        "nome": "ARAWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.751492,
        "lat": 43.260343,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.751492,
                43.260343
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 856,
        "nome": "ARAY1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.769554,
        "lat": 43.324718,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.769554,
                43.324718
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5808,
        "nome": "ARA_1",
        "nazionale": false,
        "type": "Primary",
        "lng": 11.838115462667,
        "lat": 43.459597726327,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.838115462667,
                43.459597726327
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6063,
        "nome": "ARBCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.66609298,
        "lat": 43.499842,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.66609298,
                43.499842
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1010,
        "nome": "ARBDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.039778,
        "lat": 43.677389,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.039778,
                43.677389
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2707,
        "nome": "ARBEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.793018,
        "lat": 43.78162,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.793018,
                43.78162
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 13,
        "nome": "AR_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 11.874012,
        "lat": 43.46927,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.874012,
                43.46927
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4855,
        "nome": "AR_08",
        "nazionale": false,
        "type": "Primary",
        "lng": 11.803747177124,
        "lat": 43.699886322021,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.803747177124,
                43.699886322021
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1011,
        "nome": "ATACA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.262205,
        "lat": 45.052446,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.262205,
                45.052446
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4937,
        "nome": "ATAGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.969287,
        "lat": 45.0796938,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.969287,
                45.0796938
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2380,
        "nome": "ATAHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.116532,
        "lat": 44.839961,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.116532,
                44.839961
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5124,
        "nome": "ATAOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.291763,
        "lat": 44.665479,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.291763,
                44.665479
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6126,
        "nome": "ATAPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.948612,
        "lat": 45.022562,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.948612,
                45.022562
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1012,
        "nome": "ATARA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.242539,
        "lat": 44.997879,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.242539,
                44.997879
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2041,
        "nome": "ATAV1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.0081642,
        "lat": 45.00422942,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.0081642,
                45.00422942
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2709,
        "nome": "ATAWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.33413974,
        "lat": 45.02281734,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.33413974,
                45.02281734
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6530,
        "nome": "ATAYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.357007,
        "lat": 44.820404,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.357007,
                44.820404
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1904,
        "nome": "ATAZ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.377607,
        "lat": 44.722557,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.377607,
                44.722557
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3803,
        "nome": "ATAZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.377607,
        "lat": 44.722557,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.377607,
                44.722557
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2375,
        "nome": "ATBDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.432545,
        "lat": 44.750853,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.432545,
                44.750853
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6079,
        "nome": "ATBGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.28487,
        "lat": 44.788388,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.28487,
                44.788388
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5293,
        "nome": "ATBHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.961639,
        "lat": 45.0411719,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.961639,
                45.0411719
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1013,
        "nome": "ATBJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.03735,
        "lat": 45.046603,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.03735,
                45.046603
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5150,
        "nome": "ATBKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.3595813,
        "lat": 44.8737771,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.3595813,
                44.8737771
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1812,
        "nome": "ATBL1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.243814,
        "lat": 44.647972,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.243814,
                44.647972
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1014,
        "nome": "ATBMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.122571,
        "lat": 44.986449,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.122571,
                44.986449
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2183,
        "nome": "ATBOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.039239,
        "lat": 45.087181,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.039239,
                45.087181
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3777,
        "nome": "ATBQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.0617152,
        "lat": 44.9574682,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.0617152,
                44.9574682
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3121,
        "nome": "ATBR1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.08959339,
        "lat": 45.01522505,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.08959339,
                45.01522505
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6531,
        "nome": "ATBTA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.3570069,
        "lat": 44.8204038,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.3570069,
                44.8204038
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2406,
        "nome": "ATBWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.97892648,
        "lat": 44.91929583,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.97892648,
                44.91929583
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4793,
        "nome": "ATBZ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.301831,
        "lat": 44.997688,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.301831,
                44.997688
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2112,
        "nome": "ATCAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.31355703,
        "lat": 45.03891548,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.31355703,
                45.03891548
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2113,
        "nome": "ATCBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.374656,
        "lat": 44.801488,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.374656,
                44.801488
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1974,
        "nome": "ATCD1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.258535,
        "lat": 44.668852,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.258535,
                44.668852
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6398,
        "nome": "ATCGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.275443,
        "lat": 44.760349,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.275443,
                44.760349
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6532,
        "nome": "ATCHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.4544213,
        "lat": 44.7688457,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.4544213,
                44.7688457
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2317,
        "nome": "ATCIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.294416,
        "lat": 44.82319,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.294416,
                44.82319
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5960,
        "nome": "ATCJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.072226,
        "lat": 44.935482,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.072226,
                44.935482
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2066,
        "nome": "ATCKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.3257362,
        "lat": 44.6463393,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.3257362,
                44.6463393
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3839,
        "nome": "ATCLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.932557,
        "lat": 45.067966,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.932557,
                45.067966
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6127,
        "nome": "ATCMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.218156,
        "lat": 44.849203,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.218156,
                44.849203
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 845,
        "nome": "ATCN1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.387217,
        "lat": 44.698511,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.387217,
                44.698511
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5161,
        "nome": "ATCO1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.2573902,
        "lat": 44.82860036,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.2573902,
                44.82860036
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6399,
        "nome": "ATCPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.11069,
        "lat": 44.998609,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.11069,
                44.998609
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1015,
        "nome": "ATCQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.240627,
        "lat": 44.82033,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.240627,
                44.82033
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1016,
        "nome": "ATCRA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.34188,
        "lat": 44.988005,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.34188,
                44.988005
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2442,
        "nome": "ATCVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.254574,
        "lat": 45.027956,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.254574,
                45.027956
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2248,
        "nome": "ATDBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.34456976,
        "lat": 44.93850343,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.34456976,
                44.93850343
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1858,
        "nome": "ATDC1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.163624,
        "lat": 44.856332,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.163624,
                44.856332
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2649,
        "nome": "ATDDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.027378,
        "lat": 44.950483,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.027378,
                44.950483
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6370,
        "nome": "ATDFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.28867257,
        "lat": 44.87284333,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.28867257,
                44.87284333
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2384,
        "nome": "ATDG1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.26496391,
        "lat": 44.60397938,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.26496391,
                44.60397938
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2387,
        "nome": "ATDHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.348317,
        "lat": 44.703714,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.348317,
                44.703714
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1017,
        "nome": "ATDIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.349448,
        "lat": 44.852437,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.349448,
                44.852437
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6533,
        "nome": "ATDLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.266135,
        "lat": 44.741333,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.266135,
                44.741333
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1975,
        "nome": "ATDO1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.336135,
        "lat": 44.66799,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.336135,
                44.66799
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6223,
        "nome": "ATDPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.127919,
        "lat": 44.9645087,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.127919,
                44.9645087
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2252,
        "nome": "ATDSA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.187274,
        "lat": 45.02716599,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.187274,
                45.02716599
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6400,
        "nome": "ATDUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.22872,
        "lat": 44.63678,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.22872,
                44.63678
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1018,
        "nome": "ATDVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.057177,
        "lat": 44.998075,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.057177,
                44.998075
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2039,
        "nome": "ATDYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.13525532,
        "lat": 45.00518407,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.13525532,
                45.00518407
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1019,
        "nome": "ATDZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.034879,
        "lat": 44.915314,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.034879,
                44.915314
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6364,
        "nome": "ATEBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.317537,
        "lat": 44.80834,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.317537,
                44.80834
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4923,
        "nome": "ATECA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.152052,
        "lat": 44.7508977,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.152052,
                44.7508977
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2395,
        "nome": "ATEDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.948601,
        "lat": 44.864396,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.948601,
                44.864396
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1020,
        "nome": "ATEGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.191264,
        "lat": 44.761179,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.191264,
                44.761179
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1813,
        "nome": "ATEH1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.979796,
        "lat": 44.848779,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.979796,
                44.848779
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1939,
        "nome": "ATEJ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.109026,
        "lat": 44.817859,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.109026,
                44.817859
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5377,
        "nome": "ATEJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.109783,
        "lat": 44.817698,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.109783,
                44.817698
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1021,
        "nome": "ATEKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.962484,
        "lat": 44.906368,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.962484,
                44.906368
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2356,
        "nome": "ATEMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.001851,
        "lat": 45.118055,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.001851,
                45.118055
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2408,
        "nome": "ATEN1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.985727,
        "lat": 45.055611,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.985727,
                45.055611
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6534,
        "nome": "ATENA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.2661343,
        "lat": 44.7413325,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.2661343,
                44.7413325
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 198,
        "nome": "AT_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 8.227101,
        "lat": 44.90032,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.227101,
                44.90032
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2411,
        "nome": "AVABA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.46911,
        "lat": 40.987884,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.46911,
                40.987884
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1022,
        "nome": "AVACA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.105538,
        "lat": 41.162062,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.105538,
                41.162062
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1023,
        "nome": "AVADA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.014973,
        "lat": 41.0148,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.014973,
                41.0148
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 312,
        "nome": "AVAEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.096411,
        "lat": 40.884963,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.096411,
                40.884963
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 797,
        "nome": "AVAGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.823107,
        "lat": 40.899155,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.823107,
                40.899155
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1024,
        "nome": "AVAHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.784719,
        "lat": 41.008066,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.784719,
                41.008066
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1807,
        "nome": "AVAI1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.329016,
        "lat": 40.943091,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.329016,
                40.943091
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5128,
        "nome": "AVAKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.118055,
        "lat": 40.807866,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.118055,
                40.807866
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 724,
        "nome": "AVALA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.38537,
        "lat": 40.999719,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.38537,
                40.999719
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2734,
        "nome": "AVAMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.998631,
        "lat": 41.093993,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.998631,
                41.093993
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2419,
        "nome": "AVAQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.2078,
        "lat": 41.028534,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.2078,
                41.028534
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4784,
        "nome": "AVATA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.043587,
        "lat": 40.928751,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.043587,
                40.928751
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4799,
        "nome": "AVAUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.9857874,
        "lat": 40.9282277,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.9857874,
                40.9282277
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2421,
        "nome": "AVAXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.776837,
        "lat": 40.870318,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.776837,
                40.870318
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2424,
        "nome": "AVAZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.745931,
        "lat": 40.855011,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.745931,
                40.855011
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 732,
        "nome": "AVBAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.103404,
        "lat": 41.007079,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.103404,
                41.007079
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2069,
        "nome": "AVBCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.168559,
        "lat": 41.25476,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.168559,
                41.25476
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2771,
        "nome": "AVBEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.7996887,
        "lat": 40.9575877,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.7996887,
                40.9575877
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1888,
        "nome": "AVBG1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.420361,
        "lat": 41.049326,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.420361,
                41.049326
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1944,
        "nome": "AVBHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.948714,
        "lat": 40.985868,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.948714,
                40.985868
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4800,
        "nome": "AVBJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.9918852,
        "lat": 40.9892138,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.9918852,
                40.9892138
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 870,
        "nome": "AVBK1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.851799,
        "lat": 40.941046,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.851799,
                40.941046
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4801,
        "nome": "AVBMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.7362497,
        "lat": 40.9205233,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.7362497,
                40.9205233
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4938,
        "nome": "AVBNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.005062,
        "lat": 41.048071,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.005062,
                41.048071
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3822,
        "nome": "AVBOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.2302876,
        "lat": 41.2393521,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.2302876,
                41.2393521
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2433,
        "nome": "AVBPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.027624,
        "lat": 41.215802,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.027624,
                41.215802
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1889,
        "nome": "AVBQ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.884833,
        "lat": 40.963917,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.884833,
                40.963917
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2177,
        "nome": "AVBRA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.7116965,
        "lat": 40.8909659,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.7116965,
                40.8909659
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4802,
        "nome": "AVBUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.988587,
        "lat": 40.9141323,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.988587,
                40.9141323
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4924,
        "nome": "AVBVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.8988222,
        "lat": 41.0105498,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.8988222,
                41.0105498
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 733,
        "nome": "AVBW1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.531728,
        "lat": 41.002036,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.531728,
                41.002036
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3823,
        "nome": "AVCAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.02938,
        "lat": 40.972467,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.02938,
                40.972467
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2178,
        "nome": "AVCBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.732028,
        "lat": 40.992833,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.732028,
                40.992833
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1026,
        "nome": "AVCCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.847864,
        "lat": 40.991952,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.847864,
                40.991952
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1027,
        "nome": "AVCFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.889925,
        "lat": 40.918548,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.889925,
                40.918548
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5590,
        "nome": "AVCGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.9727719,
        "lat": 40.9573209,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.9727719,
                40.9573209
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1028,
        "nome": "AVCH1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.855663,
        "lat": 40.878831,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.855663,
                40.878831
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2480,
        "nome": "AVCLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.875914,
        "lat": 40.870945,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.875914,
                40.870945
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5044,
        "nome": "AVCMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.739905,
        "lat": 40.976061,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.739905,
                40.976061
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2101,
        "nome": "AVCNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.997108,
        "lat": 41.004545,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.997108,
                41.004545
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2497,
        "nome": "AVCPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.8686701,
        "lat": 40.8937766,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.8686701,
                40.8937766
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2772,
        "nome": "AVCQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.1756866,
        "lat": 41.2277988,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.1756866,
                41.2277988
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4872,
        "nome": "AVCR1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.29157809,
        "lat": 41.07710658,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.29157809,
                41.07710658
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4925,
        "nome": "AVCWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.751846,
        "lat": 40.950063,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.751846,
                40.950063
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2071,
        "nome": "AVCZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.8998025,
        "lat": 41.0276275,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.8998025,
                41.0276275
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 649,
        "nome": "AVDAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.253232,
        "lat": 41.040568,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.253232,
                41.040568
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1029,
        "nome": "AVDC1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.915533,
        "lat": 41.048664,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.915533,
                41.048664
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2450,
        "nome": "AVDEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.157566,
        "lat": 41.121556,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.157566,
                41.121556
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6224,
        "nome": "AVDFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.921411,
        "lat": 40.884981,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.921411,
                40.884981
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1808,
        "nome": "AVDG1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.2022,
        "lat": 41.129885,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.2022,
                41.129885
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 648,
        "nome": "AVDHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.01142,
        "lat": 41.235795,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.01142,
                41.235795
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3991,
        "nome": "AVDIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.6356,
        "lat": 41.0291,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.6356,
                41.0291
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2228,
        "nome": "AVDJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.7789214,
        "lat": 41.0529997,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.7789214,
                41.0529997
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2114,
        "nome": "AVDKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.8529862,
        "lat": 41.0352236,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.8529862,
                41.0352236
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3472,
        "nome": "AVDLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.796664,
        "lat": 41.031263,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.796664,
                41.031263
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1030,
        "nome": "AVDOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.595433,
        "lat": 41.045984,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.595433,
                41.045984
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4803,
        "nome": "AVDPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.6545,
        "lat": 41.036833,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.6545,
                41.036833
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6371,
        "nome": "AVDSA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.824598,
        "lat": 41.010744,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.824598,
                41.010744
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2256,
        "nome": "AVDVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.583506,
        "lat": 40.8783201,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.583506,
                40.8783201
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6372,
        "nome": "AVEAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.60479112,
        "lat": 40.89577232,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.60479112,
                40.89577232
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4804,
        "nome": "AVEBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.634813,
        "lat": 40.949386,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.634813,
                40.949386
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2456,
        "nome": "AVECA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.645397,
        "lat": 40.867631,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.645397,
                40.867631
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6225,
        "nome": "AVEEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.607877,
        "lat": 40.954628,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.607877,
                40.954628
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2262,
        "nome": "AVEFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.6320937,
        "lat": 40.8837309,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.6320937,
                40.8837309
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3473,
        "nome": "AVEHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.2234757,
        "lat": 40.7824604,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.2234757,
                40.7824604
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1031,
        "nome": "AVEIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.234001,
        "lat": 40.822041,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.234001,
                40.822041
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4926,
        "nome": "AVEJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.338031,
        "lat": 40.860425,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.338031,
                40.860425
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3055,
        "nome": "AVEMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.2047463,
        "lat": 40.7390792,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.2047463,
                40.7390792
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2460,
        "nome": "AVENA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.258484,
        "lat": 40.85077,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.258484,
                40.85077
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4847,
        "nome": "AV_07",
        "nazionale": false,
        "type": "Primary",
        "lng": 14.619820594788,
        "lat": 40.949619293213,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.619820594788,
                40.949619293213
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2461,
        "nome": "BAAAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.25941,
        "lat": 40.915875,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.25941,
                40.915875
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3833,
        "nome": "BAABA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.9182617,
        "lat": 41.0399915,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.9182617,
                41.0399915
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3970,
        "nome": "BAABB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.9094015,
        "lat": 41.0624067,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.9094015,
                41.0624067
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4939,
        "nome": "BAACA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.818085,
        "lat": 41.062649,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.818085,
                41.062649
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2445,
        "nome": "BAADA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.926841,
        "lat": 41.00992,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.926841,
                41.00992
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2509,
        "nome": "BAAEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.714131,
        "lat": 41.029268,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.714131,
                41.029268
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3778,
        "nome": "BAAFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.9357953,
        "lat": 41.0614256,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.9357953,
                41.0614256
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3328,
        "nome": "BAAFB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.9569172,
        "lat": 41.0914968,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.9569172,
                41.0914968
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5507,
        "nome": "BAAHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.7224367,
        "lat": 41.1684067,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.7224367,
                41.1684067
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2463,
        "nome": "BAAHB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.6933565,
        "lat": 41.1775086,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.6933565,
                41.1775086
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1948,
        "nome": "BAAIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.941341,
        "lat": 40.860693,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.941341,
                40.860693
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5336,
        "nome": "BAAJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.8605273,
        "lat": 41.10195343,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.8605273,
                41.10195343
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5559,
        "nome": "BAAJB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.8795628,
        "lat": 41.10147247,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.8795628,
                41.10147247
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4975,
        "nome": "BAAKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.1380112,
        "lat": 41.0374119,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.1380112,
                41.0374119
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5859,
        "nome": "BAALA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.02432,
        "lat": 40.907317,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.02432,
                40.907317
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3474,
        "nome": "BAAMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.7083738,
        "lat": 41.0516585,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.7083738,
                41.0516585
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5857,
        "nome": "BAANA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.964573,
        "lat": 41.029386,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.964573,
                41.029386
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5858,
        "nome": "BAANB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.9904785,
        "lat": 41.0780512,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.9904785,
                41.0780512
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2467,
        "nome": "BAAOB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.6381816,
        "lat": 40.9391939,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.6381816,
                40.9391939
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5606,
        "nome": "BAAPB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.41225,
        "lat": 41.0831546,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.41225,
                41.0831546
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6226,
        "nome": "BAAQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.723244,
        "lat": 40.88525,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.723244,
                40.88525
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6227,
        "nome": "BAAQB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.7551437,
        "lat": 40.8862877,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.7551437,
                40.8862877
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2468,
        "nome": "BAARA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.5757833,
        "lat": 40.9652101,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.5757833,
                40.9652101
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2273,
        "nome": "BAATA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.9277307,
        "lat": 40.9508741,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.9277307,
                40.9508741
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2368,
        "nome": "BAATB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.9231571,
        "lat": 40.9877992,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.9231571,
                40.9877992
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3869,
        "nome": "BAAUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.7516122,
        "lat": 41.0493499,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.7516122,
                41.0493499
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3827,
        "nome": "BAAVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.8648105,
        "lat": 40.8979421,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.8648105,
                40.8979421
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4940,
        "nome": "BAAWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.0325611,
        "lat": 41.0016216,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.0325611,
                41.0016216
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4941,
        "nome": "BAAWB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.979545,
        "lat": 41.0048562,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.979545,
                41.0048562
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5509,
        "nome": "BAAYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.1192415,
        "lat": 40.783458,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.1192415,
                40.783458
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5511,
        "nome": "BAAYB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.1192415,
        "lat": 40.783458,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.1192415,
                40.783458
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2179,
        "nome": "BAAZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.582311,
        "lat": 41.116416,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.582311,
                41.116416
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5534,
        "nome": "BABCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.1834,
        "lat": 40.452776,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.1834,
                40.452776
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6373,
        "nome": "BABDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.71212744,
        "lat": 41.10095071,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.71212744,
                41.10095071
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6374,
        "nome": "BABDB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.6928479,
        "lat": 41.12007307,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.6928479,
                41.12007307
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6375,
        "nome": "BABDC",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.56361575,
        "lat": 41.0496759,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.56361575,
                41.0496759
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3819,
        "nome": "BABEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.2456351,
        "lat": 40.7794626,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.2456351,
                40.7794626
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6376,
        "nome": "BABEB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.2149816,
        "lat": 40.7751882,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.2149816,
                40.7751882
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3828,
        "nome": "BABEC",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.220569,
        "lat": 40.80094,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.220569,
                40.80094
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6535,
        "nome": "BABFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.34256,
        "lat": 41.10152,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.34256,
                41.10152
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6536,
        "nome": "BABFB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.34256,
        "lat": 41.10152,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.34256,
                41.10152
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3829,
        "nome": "BABGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.191183,
        "lat": 40.957847,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.191183,
                40.957847
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4942,
        "nome": "BABHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.9149829,
        "lat": 40.8016844,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.9149829,
                40.8016844
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4943,
        "nome": "BABHB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.9325288,
        "lat": 40.7827072,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.9325288,
                40.7827072
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4944,
        "nome": "BABHC",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.9043039,
        "lat": 40.7745976,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.9043039,
                40.7745976
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4946,
        "nome": "BABHD",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.8987844,
        "lat": 40.8114475,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.8987844,
                40.8114475
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6401,
        "nome": "BABIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.107634,
        "lat": 40.840069,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.107634,
                40.840069
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6402,
        "nome": "BABIB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.104643,
        "lat": 40.869293,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.104643,
                40.869293
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2374,
        "nome": "BABJB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.41941132,
        "lat": 40.82699736,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.41941132,
                40.82699736
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2535,
        "nome": "BABJC",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.44968782,
        "lat": 40.82647559,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.44968782,
                40.82647559
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6537,
        "nome": "BABKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.74047,
        "lat": 40.79274,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.74047,
                40.79274
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6377,
        "nome": "BABMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.19685231,
        "lat": 40.91187715,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.19685231,
                40.91187715
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6378,
        "nome": "BABMB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.17479591,
        "lat": 40.88602812,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.17479591,
                40.88602812
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6348,
        "nome": "BABMC",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.16680841,
        "lat": 40.9014412,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.16680841,
                40.9014412
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6349,
        "nome": "BABMD",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.17211835,
        "lat": 40.8590821,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.17211835,
                40.8590821
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6403,
        "nome": "BABNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.38893,
        "lat": 41.121294,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.38893,
                41.121294
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6404,
        "nome": "BABNB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.41326508,
        "lat": 41.15379819,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.41326508,
                41.15379819
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2656,
        "nome": "BABOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.27182446,
        "lat": 40.92154079,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.27182446,
                40.92154079
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2686,
        "nome": "BABOB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.24631,
        "lat": 40.95686525,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.24631,
                40.95686525
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3056,
        "nome": "BABPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.805,
        "lat": 41.016,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.805,
                41.016
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3148,
        "nome": "BABPB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 16.7577,
        "lat": 40.9493,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.7577,
                40.9493
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 55,
        "nome": "BA_01",
        "nazionale": true,
        "type": "Nazionale",
        "lng": 16.877051,
        "lat": 41.091967,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.877051,
                41.091967
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 74,
        "nome": "BA_02",
        "nazionale": false,
        "type": "Primary",
        "lng": 16.856688,
        "lat": 41.12775,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.856688,
                41.12775
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 94,
        "nome": "BA_03",
        "nazionale": false,
        "type": "Primary",
        "lng": 16.694665,
        "lat": 41.114055,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.694665,
                41.114055
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 175,
        "nome": "BA_04",
        "nazionale": false,
        "type": "Primary",
        "lng": 16.593884,
        "lat": 41.192881,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.593884,
                41.192881
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 174,
        "nome": "BA_05",
        "nazionale": false,
        "type": "Primary",
        "lng": 16.41135,
        "lat": 41.14913,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.41135,
                41.14913
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 153,
        "nome": "BA_06",
        "nazionale": false,
        "type": "Primary",
        "lng": 16.790003,
        "lat": 41.11811,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.790003,
                41.11811
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 590,
        "nome": "BA_07",
        "nazionale": false,
        "type": "Primary",
        "lng": 16.552403,
        "lat": 40.820627,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.552403,
                40.820627
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 274,
        "nome": "BA_08",
        "nazionale": false,
        "type": "Primary",
        "lng": 17.290522,
        "lat": 40.952803,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.290522,
                40.952803
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5065,
        "nome": "BA_24",
        "nazionale": false,
        "type": "Primary",
        "lng": 16.914419174194,
        "lat": 41.04761505127,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                16.914419174194,
                41.04761505127
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5129,
        "nome": "BGAAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.735166,
        "lat": 45.7038979,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.735166,
                45.7038979
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6228,
        "nome": "BGAEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.133852,
        "lat": 45.855548,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.133852,
                45.855548
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1032,
        "nome": "BGAFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.73194,
        "lat": 45.876313,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.73194,
                45.876313
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 380,
        "nome": "BGAGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.851178,
        "lat": 45.814253,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.851178,
                45.814253
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1033,
        "nome": "BGAHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.665491,
        "lat": 45.795183,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.665491,
                45.795183
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1034,
        "nome": "BGAIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.928486,
        "lat": 45.966713,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.928486,
                45.966713
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1035,
        "nome": "BGAJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.095296,
        "lat": 45.996414,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.095296,
                45.996414
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1036,
        "nome": "BGAKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.919028,
        "lat": 45.764032,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.919028,
                45.764032
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1037,
        "nome": "BGAMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.674343,
        "lat": 45.94431,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.674343,
                45.94431
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6538,
        "nome": "BGAPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.946838,
        "lat": 45.699226,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.946838,
                45.699226
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1038,
        "nome": "BGAVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.583967,
        "lat": 45.72903,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.583967,
                45.72903
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2530,
        "nome": "BGAY1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.54922401,
        "lat": 45.72068128,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.54922401,
                45.72068128
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3809,
        "nome": "BGAYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.545717,
        "lat": 45.714776,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.545717,
                45.714776
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5810,
        "nome": "BGA_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 9.5901411,
        "lat": 45.7064174,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.5901411,
                45.7064174
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3193,
        "nome": "BGBCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.604699,
        "lat": 45.493995,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.604699,
                45.493995
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5884,
        "nome": "BGBG1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.11281471,
        "lat": 45.97902681,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.11281471,
                45.97902681
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5045,
        "nome": "BGBIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.779333,
        "lat": 45.474944,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.779333,
                45.474944
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2474,
        "nome": "BGBNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.9039609,
        "lat": 45.7246933,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.9039609,
                45.7246933
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2488,
        "nome": "BGBO1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.90906195,
        "lat": 45.7740062,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.90906195,
                45.7740062
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1969,
        "nome": "BGBS1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.554595,
        "lat": 45.689784,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.554595,
                45.689784
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5241,
        "nome": "BGBU1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.885409,
        "lat": 45.722051,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.885409,
                45.722051
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2477,
        "nome": "BGBV1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.047648,
        "lat": 45.83446,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.047648,
                45.83446
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5562,
        "nome": "BGBW1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.514123,
        "lat": 45.634308,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.514123,
                45.634308
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3511,
        "nome": "BGBXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.708065,
        "lat": 45.824763,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.708065,
                45.824763
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3220,
        "nome": "BGCCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.7573256,
        "lat": 45.6726016,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.7573256,
                45.6726016
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3329,
        "nome": "BGCDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.8036527,
        "lat": 45.6217447,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.8036527,
                45.6217447
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1039,
        "nome": "BGCGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.604699,
        "lat": 45.493995,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.604699,
                45.493995
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3830,
        "nome": "BGCHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6568407,
        "lat": 45.8972192,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6568407,
                45.8972192
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1040,
        "nome": "BGCKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.533172,
        "lat": 45.628576,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.533172,
                45.628576
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2200,
        "nome": "BGCLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.48679,
        "lat": 45.739921,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.48679,
                45.739921
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4947,
        "nome": "BGCNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.8326502,
        "lat": 45.6555381,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.8326502,
                45.6555381
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4976,
        "nome": "BGCOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.781657,
        "lat": 46.020167,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.781657,
                46.020167
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2479,
        "nome": "BGCTA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6162528,
        "lat": 45.9673122,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6162528,
                45.9673122
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1041,
        "nome": "BGCWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.018921,
        "lat": 45.899254,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.018921,
                45.899254
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2538,
        "nome": "BGCX1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.0673166,
        "lat": 45.80362525,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.0673166,
                45.80362525
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6539,
        "nome": "BGCXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.066741,
        "lat": 45.803686,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.066741,
                45.803686
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4809,
        "nome": "BGDBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.8202832,
        "lat": 45.6991581,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.8202832,
                45.6991581
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3377,
        "nome": "BGDEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.554993,
        "lat": 45.654667,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.554993,
                45.654667
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6360,
        "nome": "BGDF1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.85376247,
        "lat": 45.64690256,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.85376247,
                45.64690256
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 650,
        "nome": "BGDH1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.606227,
        "lat": 45.584404,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.606227,
                45.584404
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1043,
        "nome": "BGDI1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.828222,
        "lat": 45.551639,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.828222,
                45.551639
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2981,
        "nome": "BGDKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.100182,
        "lat": 45.976042,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.100182,
                45.976042
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4805,
        "nome": "BGDSA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.737145,
        "lat": 45.831152,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.737145,
                45.831152
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4687,
        "nome": "BGDZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.5906306,
        "lat": 45.6446784,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.5906306,
                45.6446784
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1911,
        "nome": "BGEC1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.878883,
        "lat": 45.710802,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.878883,
                45.710802
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5032,
        "nome": "BGECA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.878883,
        "lat": 45.710802,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.878883,
                45.710802
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2482,
        "nome": "BGEFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.552074,
        "lat": 45.636833,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.552074,
                45.636833
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5143,
        "nome": "BGEG1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.99215462,
        "lat": 45.8904533,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.99215462,
                45.8904533
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2526,
        "nome": "BGEIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.804878,
        "lat": 45.467371,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.804878,
                45.467371
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5046,
        "nome": "BGEJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.020767,
        "lat": 45.7581,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.020767,
                45.7581
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6540,
        "nome": "BGEKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.7576468,
        "lat": 46.0457487,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.7576468,
                46.0457487
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6350,
        "nome": "BGELA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.91243204,
        "lat": 45.69541103,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.91243204,
                45.69541103
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5131,
        "nome": "BGEN1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.52497381,
        "lat": 45.85710204,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.52497381,
                45.85710204
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3792,
        "nome": "BGEOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.948309,
        "lat": 45.9912215,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.948309,
                45.9912215
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2540,
        "nome": "BGEP1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.916637,
        "lat": 45.826337,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.916637,
                45.826337
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6541,
        "nome": "BGEPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.891166,
        "lat": 45.817305,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.891166,
                45.817305
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6189,
        "nome": "BGETA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.751078,
        "lat": 45.593349,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.751078,
                45.593349
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3480,
        "nome": "BGEWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.84566,
        "lat": 45.862029,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.84566,
                45.862029
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5506,
        "nome": "BGEYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.905654,
        "lat": 45.727821,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.905654,
                45.727821
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3397,
        "nome": "BGFAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.746794,
        "lat": 45.980149,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.746794,
                45.980149
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2990,
        "nome": "BGFE1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6734191,
        "lat": 45.93762472,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6734191,
                45.93762472
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4971,
        "nome": "BGFFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6382112,
        "lat": 45.625152,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6382112,
                45.625152
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2524,
        "nome": "BGFGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.532677,
        "lat": 45.833519,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.532677,
                45.833519
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2434,
        "nome": "BGFIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6356041,
        "lat": 45.5651016,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6356041,
                45.5651016
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6477,
        "nome": "BGFJ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.882289,
        "lat": 45.714598,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.882289,
                45.714598
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6405,
        "nome": "BGFJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.882289,
        "lat": 45.714598,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.882289,
                45.714598
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5629,
        "nome": "BGFKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.554993,
        "lat": 45.654667,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.554993,
                45.654667
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6365,
        "nome": "BGFMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.769057,
        "lat": 45.575001,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.769057,
                45.575001
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 686,
        "nome": "BGFNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.498188,
        "lat": 45.672028,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.498188,
                45.672028
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6542,
        "nome": "BGFOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6650899,
        "lat": 46.0110157,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6650899,
                46.0110157
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6229,
        "nome": "BGFSA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.805079,
        "lat": 45.672395,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.805079,
                45.672395
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3103,
        "nome": "BGFT1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.7022097,
        "lat": 45.53200212,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.7022097,
                45.53200212
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3752,
        "nome": "BGFWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6052941,
        "lat": 45.7104166,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6052941,
                45.7104166
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2724,
        "nome": "BGFZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.7689228,
        "lat": 45.8919808,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.7689228,
                45.8919808
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5513,
        "nome": "BGGA1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.945676,
        "lat": 45.914994,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.945676,
                45.914994
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3330,
        "nome": "BGGDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.5750445,
        "lat": 45.9909356,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.5750445,
                45.9909356
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 573,
        "nome": "BGGKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.897561,
        "lat": 45.875773,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.897561,
                45.875773
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1861,
        "nome": "BGGL1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.031365,
        "lat": 45.739209,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.031365,
                45.739209
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3787,
        "nome": "BGGLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.031365,
        "lat": 45.739209,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.031365,
                45.739209
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2814,
        "nome": "BGGMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.89329361,
        "lat": 45.80309932,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.89329361,
                45.80309932
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5212,
        "nome": "BGGNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.04837,
        "lat": 45.811601,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.04837,
                45.811601
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1862,
        "nome": "BGGO1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.928437,
        "lat": 45.898116,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.928437,
                45.898116
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4977,
        "nome": "BGGPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6808647,
        "lat": 45.9905461,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6808647,
                45.9905461
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2490,
        "nome": "BGGQ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.67366576,
        "lat": 45.98192947,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.67366576,
                45.98192947
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2711,
        "nome": "BGGYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.018646,
        "lat": 45.679787,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.018646,
                45.679787
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1912,
        "nome": "BGGZ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.87709,
        "lat": 45.87154,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.87709,
                45.87154
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6543,
        "nome": "BGHBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.8694973,
        "lat": 45.4768535,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.8694973,
                45.4768535
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2514,
        "nome": "BGHGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.722143,
        "lat": 45.952443,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.722143,
                45.952443
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4949,
        "nome": "BGHHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.56102894,
        "lat": 45.76925026,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.56102894,
                45.76925026
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6230,
        "nome": "BGHLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.80734,
        "lat": 45.685332,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.80734,
                45.685332
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2548,
        "nome": "BGHNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6210451,
        "lat": 45.9836399,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6210451,
                45.9836399
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1044,
        "nome": "BGHOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.537141,
        "lat": 45.803294,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.537141,
                45.803294
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2639,
        "nome": "BGHRA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.1589888,
        "lat": 46.0088728,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.1589888,
                46.0088728
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1045,
        "nome": "BGHTA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.74645,
        "lat": 45.78318,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.74645,
                45.78318
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1046,
        "nome": "BGHVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.020526,
        "lat": 45.780051,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.020526,
                45.780051
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3753,
        "nome": "BGHYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6384824,
        "lat": 45.7328544,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6384824,
                45.7328544
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 734,
        "nome": "BGHZ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.50659,
        "lat": 45.698973,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.50659,
                45.698973
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2762,
        "nome": "BGIBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6639349,
        "lat": 45.5846271,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6639349,
                45.5846271
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4950,
        "nome": "BGIEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.0470523,
        "lat": 45.7103746,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.0470523,
                45.7103746
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6231,
        "nome": "BGIFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.859042,
        "lat": 45.6272016,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.859042,
                45.6272016
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 379,
        "nome": "BGIHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.712418,
        "lat": 45.71186,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.712418,
                45.71186
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5514,
        "nome": "BGIMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6169925,
        "lat": 45.7828972,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6169925,
                45.7828972
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3425,
        "nome": "BGINA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.691442,
        "lat": 45.611242,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.691442,
                45.611242
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1047,
        "nome": "BGIOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.595119,
        "lat": 45.823213,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.595119,
                45.823213
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4978,
        "nome": "BGIXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.6231566,
        "lat": 45.6008347,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.6231566,
                45.6008347
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2202,
        "nome": "BGIZ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.89102974,
        "lat": 45.73198737,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.89102974,
                45.73198737
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3971,
        "nome": "BGIZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.90072,
        "lat": 45.725129,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.90072,
                45.725129
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2726,
        "nome": "BGJBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.4718,
        "lat": 45.709064,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.4718,
                45.709064
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6351,
        "nome": "BGJCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.61175343,
        "lat": 45.74477047,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.61175343,
                45.74477047
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3027,
        "nome": "BGJEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.92861,
        "lat": 45.906135,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.92861,
                45.906135
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2534,
        "nome": "BGJFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.922203,
        "lat": 45.670297,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.922203,
                45.670297
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6406,
        "nome": "BGJHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.68466,
        "lat": 45.635669,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.68466,
                45.635669
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 66,
        "nome": "BG_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 9.657109,
        "lat": 45.688775,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.657109,
                45.688775
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 137,
        "nome": "BG_02",
        "nazionale": false,
        "type": "Primary",
        "lng": 9.688771,
        "lat": 45.692445,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.688771,
                45.692445
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 597,
        "nome": "BG_03",
        "nazionale": false,
        "type": "Primary",
        "lng": 9.5910651,
        "lat": 45.5241758,
        "pop_aperto": false,
        "coordinates": {
            "coordinates": [
                9.5910651,
                45.5241758
            ],
            "type": "Point"
        },
        "show": false
    },
    {
        "id": 1048,
        "nome": "BIABA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.223739,
        "lat": 45.595993,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.223739,
                45.595993
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1049,
        "nome": "BIACA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.162174,
        "lat": 45.667608,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.162174,
                45.667608
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1050,
        "nome": "BIAEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.053558,
        "lat": 45.604744,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.053558,
                45.604744
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2507,
        "nome": "BIAFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.129776,
        "lat": 45.608883,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.129776,
                45.608883
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3623,
        "nome": "BIAGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.248139,
        "lat": 45.593778,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.248139,
                45.593778
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1051,
        "nome": "BIAJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.005561,
        "lat": 45.545338,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.005561,
                45.545338
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 735,
        "nome": "BIAL1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.114632,
        "lat": 45.529386,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.114632,
                45.529386
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4951,
        "nome": "BIAMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.212808,
        "lat": 45.69314,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.212808,
                45.69314
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4685,
        "nome": "BIAU1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.243581,
        "lat": 45.610777,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.243581,
                45.610777
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3754,
        "nome": "BIAVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.0764924,
        "lat": 45.5352389,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.0764924,
                45.5352389
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5167,
        "nome": "BIAYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.1972213,
        "lat": 45.5878336,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.1972213,
                45.5878336
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 730,
        "nome": "BIBB1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.010453,
        "lat": 45.532311,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.010453,
                45.532311
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2759,
        "nome": "BIBCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.138464,
        "lat": 45.651713,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.138464,
                45.651713
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1954,
        "nome": "BIBDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.216221,
        "lat": 45.491565,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.216221,
                45.491565
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1052,
        "nome": "BIBEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.981884,
        "lat": 45.562554,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.981884,
                45.562554
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1848,
        "nome": "BIBG1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.010569,
        "lat": 45.5648,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.010569,
                45.5648
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2515,
        "nome": "BIBIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.136595,
        "lat": 45.585751,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.136595,
                45.585751
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 731,
        "nome": "BIBL1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.995891,
        "lat": 45.580725,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.995891,
                45.580725
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3832,
        "nome": "BIBMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.050636,
        "lat": 45.537536,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.050636,
                45.537536
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2528,
        "nome": "BIBOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.039401,
        "lat": 45.592544,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.039401,
                45.592544
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2522,
        "nome": "BIBPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.195377,
        "lat": 45.678471,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.195377,
                45.678471
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2487,
        "nome": "BIBYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.975053,
        "lat": 45.570511,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.975053,
                45.570511
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 849,
        "nome": "BIBZ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.271121,
        "lat": 45.634762,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.271121,
                45.634762
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3755,
        "nome": "BICAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.1696995,
        "lat": 45.6206773,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.1696995,
                45.6206773
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1931,
        "nome": "BICC1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.118699,
        "lat": 45.588865,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.118699,
                45.588865
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3104,
        "nome": "BICDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.049213,
        "lat": 45.58981,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.049213,
                45.58981
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1053,
        "nome": "BICEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.1360978,
        "lat": 45.5673592,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.1360978,
                45.5673592
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1054,
        "nome": "BICGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.150482,
        "lat": 45.629687,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.150482,
                45.629687
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1932,
        "nome": "BICH1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.141959,
        "lat": 45.609111,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.141959,
                45.609111
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2763,
        "nome": "BICIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.10975,
        "lat": 45.638889,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.10975,
                45.638889
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2564,
        "nome": "BICKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.285608,
        "lat": 45.622778,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.285608,
                45.622778
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1055,
        "nome": "BICLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.095692,
        "lat": 45.471203,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.095692,
                45.471203
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2728,
        "nome": "BICNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.936594,
        "lat": 45.534676,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.936594,
                45.534676
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2645,
        "nome": "BICOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.9773834204,
        "lat": 45.513718876,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.9773834204,
                45.513718876
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5656,
        "nome": "BICP1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 7.95539742,
        "lat": 45.49810141,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                7.95539742,
                45.49810141
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2591,
        "nome": "BICRA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.03835,
        "lat": 45.510642,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.03835,
                45.510642
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3059,
        "nome": "BICSA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.0959944,
        "lat": 45.4086706,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.0959944,
                45.4086706
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2556,
        "nome": "BICVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.164171,
        "lat": 45.491699,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.164171,
                45.491699
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6232,
        "nome": "BICXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.072574,
        "lat": 45.521057,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.072574,
                45.521057
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3690,
        "nome": "BIDAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.051157,
        "lat": 45.4231274,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.051157,
                45.4231274
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2547,
        "nome": "BIDBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 8.037653,
        "lat": 45.4460637,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.037653,
                45.4460637
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 438,
        "nome": "BI_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 8.037025,
        "lat": 45.555498,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                8.037025,
                45.555498
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2559,
        "nome": "BLABA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.38031,
        "lat": 46.14418,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.38031,
                46.14418
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1056,
        "nome": "BLAFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.887494,
        "lat": 46.357784,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.887494,
                46.357784
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1057,
        "nome": "BLAGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.211992,
        "lat": 46.449658,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.211992,
                46.449658
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 736,
        "nome": "BLAIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.036551,
        "lat": 46.278026,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.036551,
                46.278026
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 367,
        "nome": "BLAJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.923755,
        "lat": 45.90864,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.923755,
                45.90864
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1058,
        "nome": "BLAKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.797625,
        "lat": 46.0144111,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.797625,
                46.0144111
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 737,
        "nome": "BLAO1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.219033,
        "lat": 46.437197,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.219033,
                46.437197
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5591,
        "nome": "BLAPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.386992,
        "lat": 46.444898,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.386992,
                46.444898
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4667,
        "nome": "BLATA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.292313,
        "lat": 46.393628,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.292313,
                46.393628
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2610,
        "nome": "BLAU1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.016897,
        "lat": 46.45102,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.016897,
                46.45102
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6544,
        "nome": "BLAUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.016897,
        "lat": 46.45102,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.016897,
                46.45102
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1061,
        "nome": "BLAVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.474895,
        "lat": 46.615039,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.474895,
                46.615039
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4787,
        "nome": "BLBFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.170589,
        "lat": 46.094917,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.170589,
                46.094917
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2618,
        "nome": "BLBI1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.456929,
        "lat": 46.481539,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.456929,
                46.481539
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3143,
        "nome": "BLBIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.456971,
        "lat": 46.481508,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.456971,
                46.481508
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1064,
        "nome": "BLBKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.108528,
        "lat": 46.072103,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.108528,
                46.072103
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3481,
        "nome": "BLBMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.87615,
        "lat": 46.032697,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.87615,
                46.032697
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1921,
        "nome": "BLBN1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.367223,
        "lat": 46.389002,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.367223,
                46.389002
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6545,
        "nome": "BLBNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.367294,
        "lat": 46.388993,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.367294,
                46.388993
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5610,
        "nome": "BLBOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.361709,
        "lat": 46.162776,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.361709,
                46.162776
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 739,
        "nome": "BLBU1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.023838,
        "lat": 46.097831,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.023838,
                46.097831
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2872,
        "nome": "BLBVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.52817394,
        "lat": 46.57924979,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.52817394,
                46.57924979
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2641,
        "nome": "BLBXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.98966,
        "lat": 46.383044,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.98966,
                46.383044
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1066,
        "nome": "BLBYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.037845,
        "lat": 46.078182,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.037845,
                46.078182
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6658,
        "nome": "BLCB1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.035714,
        "lat": 46.45046,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.035714,
                46.45046
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6546,
        "nome": "BLCBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.035714,
        "lat": 46.45046,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.035714,
                46.45046
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1999,
        "nome": "BLCE1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.300954,
        "lat": 46.200644,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.300954,
                46.200644
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6547,
        "nome": "BLCEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.300954,
        "lat": 46.200644,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.300954,
                46.200644
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1067,
        "nome": "BLCHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.420457,
        "lat": 46.127519,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.420457,
                46.127519
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1068,
        "nome": "BLCLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 12.458293,
        "lat": 46.48784,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.458293,
                46.48784
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 162,
        "nome": "BL_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 12.138157,
        "lat": 46.534163,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.138157,
                46.534163
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 452,
        "nome": "BL_02",
        "nazionale": false,
        "type": "Primary",
        "lng": 12.209923,
        "lat": 46.153665,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                12.209923,
                46.153665
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2609,
        "nome": "BNAAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.734749,
        "lat": 41.177945,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.734749,
                41.177945
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1804,
        "nome": "BNAB1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.463363,
        "lat": 41.203936,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.463363,
                41.203936
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 314,
        "nome": "BNADA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.557623,
        "lat": 41.286552,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.557623,
                41.286552
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4806,
        "nome": "BNAEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.580147,
        "lat": 41.04027,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.580147,
                41.04027
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3834,
        "nome": "BNAGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.9331438,
        "lat": 41.274212,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.9331438,
                41.274212
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2730,
        "nome": "BNAIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.951533,
        "lat": 41.135485,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.951533,
                41.135485
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1070,
        "nome": "BNAJ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.740542,
        "lat": 41.085053,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.740542,
                41.085053
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2642,
        "nome": "BNALA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.744769,
        "lat": 41.032719,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.744769,
                41.032719
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2578,
        "nome": "BNANA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.566358,
        "lat": 41.071615,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.566358,
                41.071615
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2939,
        "nome": "BNAPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.862124,
        "lat": 41.0675546,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.862124,
                41.0675546
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4953,
        "nome": "BNARA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.645721,
        "lat": 41.132052,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.645721,
                41.132052
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2966,
        "nome": "BNASA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.7011405,
        "lat": 41.26164,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.7011405,
                41.26164
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2733,
        "nome": "BNAUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.809922,
        "lat": 41.401367,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.809922,
                41.401367
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4979,
        "nome": "BNAWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.548144,
        "lat": 41.232771,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.548144,
                41.232771
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5671,
        "nome": "BNAYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.642174,
        "lat": 41.147813,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.642174,
                41.147813
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5047,
        "nome": "BNAZA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.774247,
        "lat": 41.069815,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.774247,
                41.069815
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3756,
        "nome": "BNBBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.833974,
        "lat": 41.361127,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.833974,
                41.361127
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3039,
        "nome": "BNBCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.50974,
        "lat": 41.336449,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.50974,
                41.336449
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1071,
        "nome": "BNBEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.67424,
        "lat": 41.159653,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.67424,
                41.159653
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5048,
        "nome": "BNBFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.982084,
        "lat": 41.354733,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.982084,
                41.354733
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2582,
        "nome": "BNBHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.783402,
        "lat": 41.2564,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.783402,
                41.2564
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2584,
        "nome": "BNBKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.041528,
        "lat": 41.280806,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.041528,
                41.280806
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4688,
        "nome": "BNBMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.503407,
        "lat": 41.1642032,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.503407,
                41.1642032
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4980,
        "nome": "BNBNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.541045,
        "lat": 41.082086,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.541045,
                41.082086
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3861,
        "nome": "BNBPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.010348,
        "lat": 41.323856,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.010348,
                41.323856
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1805,
        "nome": "BNBR1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.689524,
        "lat": 41.343981,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.689524,
                41.343981
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1073,
        "nome": "BNBSA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.885246,
        "lat": 41.16913,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.885246,
                41.16913
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3847,
        "nome": "BNBTA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.8668,
        "lat": 41.24443,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.8668,
                41.24443
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4666,
        "nome": "BNBUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.7030635,
        "lat": 41.0089948,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.7030635,
                41.0089948
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 559,
        "nome": "BNBY1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.843047,
        "lat": 41.193616,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.843047,
                41.193616
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2588,
        "nome": "BNCBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.826215,
        "lat": 41.292042,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.826215,
                41.292042
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 315,
        "nome": "BNCCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 15.02076,
        "lat": 41.423258,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                15.02076,
                41.423258
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1074,
        "nome": "BNCIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.877841,
        "lat": 41.313048,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.877841,
                41.313048
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4954,
        "nome": "BNCLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.821901,
        "lat": 41.071395,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.821901,
                41.071395
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1075,
        "nome": "BNCM1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.478441,
        "lat": 41.230834,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.478441,
                41.230834
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1887,
        "nome": "BNCN1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.73124,
        "lat": 41.388945,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.73124,
                41.388945
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1076,
        "nome": "BNCOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.807683,
        "lat": 41.074992,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.807683,
                41.074992
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4807,
        "nome": "BNCPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.924691,
        "lat": 41.139946,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.924691,
                41.139946
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1806,
        "nome": "BNCQ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.665814,
        "lat": 41.37555,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.665814,
                41.37555
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3905,
        "nome": "BNCRA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.544895,
        "lat": 41.192401,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.544895,
                41.192401
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5592,
        "nome": "BNCSA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.510028,
        "lat": 41.215417,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.510028,
                41.215417
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4955,
        "nome": "BNCUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.678404,
        "lat": 41.18976,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.678404,
                41.18976
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2598,
        "nome": "BNCWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.449228,
        "lat": 41.125569,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.449228,
                41.125569
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2615,
        "nome": "BNCX1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.44709046,
        "lat": 41.05951085,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.44709046,
                41.05951085
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1077,
        "nome": "BNCYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 14.406376,
        "lat": 41.130445,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.406376,
                41.130445
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 179,
        "nome": "BN_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 14.774259,
        "lat": 41.129626,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                14.774259,
                41.129626
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 145,
        "nome": "BO/FCO/1",
        "nazionale": false,
        "type": "Primary",
        "lng": 11.3570355,
        "lat": 44.5086597,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.3570355,
                44.5086597
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 146,
        "nome": "BO/FCO/2",
        "nazionale": false,
        "type": "Primary",
        "lng": 11.3162409,
        "lat": 44.4953231,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.3162409,
                44.4953231
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 356,
        "nome": "BOACA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.593953,
        "lat": 44.277864,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.593953,
                44.277864
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1078,
        "nome": "BOADA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.371751,
        "lat": 44.594524,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.371751,
                44.594524
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5132,
        "nome": "BOAE1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.417906,
        "lat": 44.365021,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.417906,
                44.365021
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1079,
        "nome": "BOAEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.466495,
        "lat": 44.448421,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.466495,
                44.448421
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 876,
        "nome": "BOAGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.537964,
        "lat": 44.649367,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.537964,
                44.649367
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 877,
        "nome": "BOAIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.048433,
        "lat": 44.435524,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.048433,
                44.435524
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6407,
        "nome": "BOAIB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.108697,
        "lat": 44.50954,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.108697,
                44.50954
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6352,
        "nome": "BOAN1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.129647,
        "lat": 44.149779,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.129647,
                44.149779
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2410,
        "nome": "BOAR1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.495917,
        "lat": 44.241778,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.495917,
                44.241778
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1080,
        "nome": "BOASA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.9833348,
        "lat": 44.1745898,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.9833348,
                44.1745898
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 355,
        "nome": "BOBDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.435511,
        "lat": 44.741614,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.435511,
                44.741614
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6411,
        "nome": "BOBHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.775294,
        "lat": 44.363549,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.775294,
                44.363549
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1082,
        "nome": "BOBXA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 11.182053,
        "lat": 44.591785,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.182053,
                44.591785
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 207,
        "nome": "BOH_1",
        "nazionale": false,
        "type": "Primary",
        "lng": 11.303643,
        "lat": 44.51429,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.303643,
                44.51429
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 206,
        "nome": "BOH_2",
        "nazionale": true,
        "type": "Nazionale",
        "lng": 11.460494,
        "lat": 44.481433,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.460494,
                44.481433
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 150,
        "nome": "BOH_3",
        "nazionale": false,
        "type": "Primary",
        "lng": 11.712238,
        "lat": 44.368517,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.712238,
                44.368517
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 527,
        "nome": "BO_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 11.3570355,
        "lat": 44.5086597,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.3570355,
                44.5086597
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 526,
        "nome": "BO_02",
        "nazionale": false,
        "type": "Primary",
        "lng": 11.3162409,
        "lat": 44.4953231,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.3162409,
                44.4953231
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 260,
        "nome": "BO_06",
        "nazionale": false,
        "type": "no FTTH",
        "lng": 11.363645,
        "lat": 44.508584,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                11.363645,
                44.508584
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5515,
        "nome": "BRAAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.9164718,
        "lat": 40.4486083,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.9164718,
                40.4486083
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5516,
        "nome": "BRAAB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.9209912,
        "lat": 40.4427802,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.9209912,
                40.4427802
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2565,
        "nome": "BRABA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.952769,
        "lat": 40.466906,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.952769,
                40.466906
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2552,
        "nome": "BRACA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.720516,
        "lat": 40.4691262,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.720516,
                40.4691262
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3484,
        "nome": "BRACB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.7432844,
        "lat": 40.4800122,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.7432844,
                40.4800122
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3691,
        "nome": "BRADA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.7504556,
        "lat": 40.5555947,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.7504556,
                40.5555947
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5517,
        "nome": "BRADB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.7911387,
        "lat": 40.5543447,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.7911387,
                40.5543447
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5518,
        "nome": "BRADC",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.8282538,
        "lat": 40.5761968,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.8282538,
                40.5761968
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1980,
        "nome": "BRAEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.814767,
        "lat": 40.419452,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.814767,
                40.419452
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5049,
        "nome": "BRAFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.7135293,
        "lat": 40.548604,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.7135293,
                40.548604
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5380,
        "nome": "BRAFB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.7043043,
        "lat": 40.5560027,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.7043043,
                40.5560027
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2738,
        "nome": "BRAGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.666458,
        "lat": 40.6947612,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.666458,
                40.6947612
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2740,
        "nome": "BRAGB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.7193754,
        "lat": 40.7463342,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.7193754,
                40.7463342
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3835,
        "nome": "BRAHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 18.0697495,
        "lat": 40.538437,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                18.0697495,
                40.538437
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3836,
        "nome": "BRAHB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 18.0107741,
        "lat": 40.4882527,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                18.0107741,
                40.4882527
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3837,
        "nome": "BRAHC",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.9992904,
        "lat": 40.4877623,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.9992904,
                40.4877623
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2050,
        "nome": "BRAIA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.722425,
        "lat": 40.440107,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.722425,
                40.440107
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5401,
        "nome": "BRAIB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.7227608,
        "lat": 40.4406226,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.7227608,
                40.4406226
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3918,
        "nome": "BRAJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.2743,
        "lat": 40.3218,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.2743,
                40.3218
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3331,
        "nome": "BRAJB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.4750079,
        "lat": 40.5747227,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.4750079,
                40.5747227
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3108,
        "nome": "BRAKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.502546,
        "lat": 40.531657,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.502546,
                40.531657
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2643,
        "nome": "BRAKB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.532122,
        "lat": 40.51122,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.532122,
                40.51122
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3110,
        "nome": "BRAKC",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.515601,
        "lat": 40.55631,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.515601,
                40.55631
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4981,
        "nome": "BRALA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.6669315,
        "lat": 40.4767936,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.6669315,
                40.4767936
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3919,
        "nome": "BRAMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.5037743,
        "lat": 40.6426147,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.5037743,
                40.6426147
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3332,
        "nome": "BRAMB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.5231327,
        "lat": 40.6366278,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.5231327,
                40.6366278
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4808,
        "nome": "BRAOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.6397816,
        "lat": 40.6290694,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.6397816,
                40.6290694
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5519,
        "nome": "BRAPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 18.0727243,
        "lat": 40.5371589,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                18.0727243,
                40.5371589
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5520,
        "nome": "BRAPB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 18.045362,
        "lat": 40.487319,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                18.045362,
                40.487319
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4690,
        "nome": "BRAQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.425232,
        "lat": 40.749724,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.425232,
                40.749724
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4691,
        "nome": "BRAQB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.4337526,
        "lat": 40.7414899,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.4337526,
                40.7414899
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4982,
        "nome": "BRARA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.971624,
        "lat": 40.629131,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.971624,
                40.629131
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4983,
        "nome": "BRARB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.9689448,
        "lat": 40.5486777,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.9689448,
                40.5486777
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4984,
        "nome": "BRARC",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.8745932,
        "lat": 40.684498,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.8745932,
                40.684498
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3041,
        "nome": "BRASA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.7026,
        "lat": 40.66697,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.7026,
                40.66697
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3117,
        "nome": "BRASB",
        "nazionale": false,
        "type": "Secondary",
        "lng": 17.7093,
        "lat": 40.6605,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.7093,
                40.6605
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 50,
        "nome": "BR_01",
        "nazionale": false,
        "type": "Primary",
        "lng": 17.923369,
        "lat": 40.626824,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                17.923369,
                40.626824
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1083,
        "nome": "BSAAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.074372,
        "lat": 45.701575,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.074372,
                45.701575
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1084,
        "nome": "BSABA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.081525,
        "lat": 45.336112,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.081525,
                45.336112
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1085,
        "nome": "BSADA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.342689,
        "lat": 46.171222,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.342689,
                46.171222
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1087,
        "nome": "BSAJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.732151,
        "lat": 45.747617,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.732151,
                45.747617
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 878,
        "nome": "BSAKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.082464,
        "lat": 45.675139,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.082464,
                45.675139
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1088,
        "nome": "BSANA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.243231,
        "lat": 45.756154,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.243231,
                45.756154
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2644,
        "nome": "BSAOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.416389,
        "lat": 45.3066,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.416389,
                45.3066
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3880,
        "nome": "BSAPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.952823,
        "lat": 45.617492,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.952823,
                45.617492
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6660,
        "nome": "BSAQ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.35943445,
        "lat": 45.63640266,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.35943445,
                45.63640266
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6548,
        "nome": "BSAQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.359434,
        "lat": 45.636403,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.359434,
                45.636403
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2786,
        "nome": "BSARA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.1337143,
        "lat": 45.2693992,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.1337143,
                45.2693992
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1089,
        "nome": "BSAUA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.163212,
        "lat": 45.845697,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.163212,
                45.845697
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 546,
        "nome": "BSAVA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.113704,
        "lat": 45.464509,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.113704,
                45.464509
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4665,
        "nome": "BSAYA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.062654,
        "lat": 45.402296,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.062654,
                45.402296
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4817,
        "nome": "BSBAA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.130105,
        "lat": 45.321374,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.130105,
                45.321374
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2614,
        "nome": "BSBCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.026944,
        "lat": 45.50325,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.026944,
                45.50325
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 740,
        "nome": "BSBE1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.268357,
        "lat": 45.92782,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.268357,
                45.92782
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4002,
        "nome": "BSBHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.967057,
        "lat": 45.34403,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.967057,
                45.34403
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5655,
        "nome": "BSBLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.267262,
        "lat": 45.789231,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.267262,
                45.789231
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5538,
        "nome": "BSBNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.050193072,
        "lat": 45.455983009,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.050193072,
                45.455983009
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1090,
        "nome": "BSBOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.339597,
        "lat": 45.988327,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.339597,
                45.988327
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1091,
        "nome": "BSBRA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.30989,
        "lat": 45.603946,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.30989,
                45.603946
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2619,
        "nome": "BSBTA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.391358,
        "lat": 45.348628,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.391358,
                45.348628
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 850,
        "nome": "BSCB1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.944084,
        "lat": 45.501867,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.944084,
                45.501867
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1092,
        "nome": "BSCHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.178541,
        "lat": 45.569575,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.178541,
                45.569575
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3127,
        "nome": "BSCI1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.32550765,
        "lat": 46.00231643,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.32550765,
                46.00231643
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4670,
        "nome": "BSCKA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.3675709,
        "lat": 46.0822956,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.3675709,
                46.0822956
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2640,
        "nome": "BSCM1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.18365741,
        "lat": 45.30428574,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.18365741,
                45.30428574
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4985,
        "nome": "BSCNA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.365311,
        "lat": 46.024011,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.365311,
                46.024011
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6366,
        "nome": "BSCQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.327964,
        "lat": 45.808493,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.327964,
                45.808493
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 687,
        "nome": "BSCZ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.993735,
        "lat": 45.583789,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.993735,
                45.583789
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3021,
        "nome": "BSDB1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.324367,
        "lat": 45.235998,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.324367,
                45.235998
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2653,
        "nome": "BSDCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.149318,
        "lat": 45.484715,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.149318,
                45.484715
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1093,
        "nome": "BSDDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.299148,
        "lat": 45.249533,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.299148,
                45.249533
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6353,
        "nome": "BSDEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.198743,
        "lat": 45.699896,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.198743,
                45.699896
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6549,
        "nome": "BSDFA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.652224,
        "lat": 45.672641,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.652224,
                45.672641
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6236,
        "nome": "BSDI1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.168657,
        "lat": 45.86764,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.168657,
                45.86764
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2657,
        "nome": "BSDJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.259922,
        "lat": 45.297033,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.259922,
                45.297033
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5612,
        "nome": "BSDLA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.357914,
        "lat": 46.216025,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.357914,
                46.216025
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2779,
        "nome": "BSDMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.285381,
        "lat": 45.7711,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.285381,
                45.7711
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 741,
        "nome": "BSDN1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.322475,
        "lat": 45.309516,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.322475,
                45.309516
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3920,
        "nome": "BSDPA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.222508,
        "lat": 45.358158,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.222508,
                45.358158
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6342,
        "nome": "BSDU1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.058134,
        "lat": 45.431508,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.058134,
                45.431508
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3123,
        "nome": "BSDWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.26004,
        "lat": 45.98562,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.26004,
                45.98562
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3815,
        "nome": "BSEB1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.27240421,
        "lat": 45.95004511,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.27240421,
                45.95004511
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6233,
        "nome": "BSECA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.327155,
        "lat": 46.131391,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.327155,
                46.131391
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1094,
        "nome": "BSEDA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.548369,
        "lat": 45.546077,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.548369,
                45.546077
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5160,
        "nome": "BSEEA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.1350198,
        "lat": 45.3437029,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.1350198,
                45.3437029
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3130,
        "nome": "BSEHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.103896,
        "lat": 45.725933,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.103896,
                45.725933
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3132,
        "nome": "BSEJA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.2088094,
        "lat": 45.2683396,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.2088094,
                45.2683396
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2664,
        "nome": "BSELA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.342467,
        "lat": 46.210666,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.342467,
                46.210666
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2705,
        "nome": "BSEMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.100437,
        "lat": 45.632153,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.100437,
                45.632153
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1095,
        "nome": "BSEQA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.464968,
        "lat": 45.549884,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.464968,
                45.549884
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2684,
        "nome": "BSET1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.38919874,
        "lat": 45.51475117,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.38919874,
                45.51475117
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 6550,
        "nome": "BSETA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.38561,
        "lat": 45.51608,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.38561,
                45.51608
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4671,
        "nome": "BSEWA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.1234522,
        "lat": 45.6261941,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.1234522,
                45.6261941
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 879,
        "nome": "BSFBA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.22756,
        "lat": 45.944998,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.22756,
                45.944998
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3838,
        "nome": "BSFCA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.5194467,
        "lat": 45.5097993,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.5194467,
                45.5097993
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 1097,
        "nome": "BSFHA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.963572,
        "lat": 45.655218,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.963572,
                45.655218
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4810,
        "nome": "BSFMA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.364078,
        "lat": 45.74638,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.364078,
                45.74638
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2742,
        "nome": "BSFOA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.247116,
        "lat": 45.9372555,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.247116,
                45.9372555
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 5614,
        "nome": "BSFQ1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.1242482,
        "lat": 45.66119599,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.1242482,
                45.66119599
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 742,
        "nome": "BSFS1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 9.995419,
        "lat": 45.436348,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                9.995419,
                45.436348
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 2679,
        "nome": "BSFT1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.18835633,
        "lat": 45.45757818,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.18835633,
                45.45757818
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 3134,
        "nome": "BSGE1",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.530957,
        "lat": 45.570258,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.530957,
                45.570258
            ],
            "type": "Point"
        },
        "show": true
    },
    {
        "id": 4972,
        "nome": "BSGGA",
        "nazionale": false,
        "type": "Secondary",
        "lng": 10.369216,
        "lat": 45.267805,
        "pop_aperto": true,
        "coordinates": {
            "coordinates": [
                10.369216,
                45.267805
            ],
            "type": "Point"
        },
        "show": true
    }]